import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { lastValueFrom, take } from 'rxjs';
import { AppResource } from 'src/app/app.resource';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { Question } from 'src/app/core/models/question.model';
import { cloneResumeStep } from 'src/app/core/models/resume-step.model';
import { Step } from 'src/app/core/models/step.model';
import { Stepper } from 'src/app/core/models/stepper.model';
import { State } from 'src/app/core/state/core.state';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { MatomoConstants } from 'src/app/shared/constants/matomo.constants';
import { ADDRESS_PATH, ROOT_PATH } from 'src/app/shared/constants/route.constants';
import { PopUpInfoVM } from 'src/app/shared/models/components/popupinfoVm';
import * as fromAddress from '../../../core/state/address';
import * as fromInfo from '../../../core/state/info';
import * as fromPath from '../../../core/state/path';
import * as fromContext from '../../../core/state/context';
import { environment } from 'src/environments/environment';
import { CONTEXT } from 'src/app/shared/constants/localstorage.constants';

@Component({
  selector: 'app-etudiant-age',
  templateUrl: './etudiant-age.component.html',
  styleUrls: ['./etudiant-age.component.scss']
})
export class EtudiantAgeComponent extends BaseComponent implements OnInit {
  override step: Step = {
    step: this.resource.header.stepHousing,
    stepNumber: 1,
    subStep: this.resource.header.subEtudiantAge,
    subStepNumber: 1
  };

  override question: Question = {
    libelle: this.resource.question.etudiantAge,
    popupInfo: new PopUpInfoVM([
      this.resource.infobulle.etudiantAge2,
      this.resource.infobulle.etudiantAge3
    ])
  };

  yesSelected = false;
  noSelected = false;
  path = PathType.HOUSING_ETUDIANTE;

  displayModal = false;

  public override currentPage = MatomoConstants.NOMBRE_COLOCATAIRE;

  constructor(store: Store<State>, resources: AppResource, private readonly router: Router) {
    super(store, resources);
  }

  override async ngOnInit() {
    super.ngOnInit();

    await this.updateStepper(this.path);
    this.updateResumeStepVisibility(false);

    this.loadData();
  }

  loadData() {
    this.store
      .select(fromAddress.selectIsEtudiant)

      .subscribe(isEtudiant => {
        if (isEtudiant !== null)
          if (isEtudiant) {
            this.yesSelected = true;
            this.noSelected = false;
          } else {
            this.yesSelected = false;
            this.noSelected = true;
          }
      });
  }

  onYesSelected() {
    if (!this.yesSelected) this.yesSelected = !this.yesSelected;
    if (this.yesSelected) {
      this.noSelected = false;
    }

    this.nextStep();
  }

  onNoSelected() {
    const localStorageContext = localStorage.getItem(CONTEXT);
    let token;
    if (localStorageContext) {
      const contextObj = JSON.parse(localStorageContext);
      token = contextObj.token;
    }

    if (!this.noSelected) this.noSelected = !this.noSelected;
    if (this.noSelected) {
      this.yesSelected = false;
    }

    window.location.href = `${environment.baseUrl}/start/${token}`;
  }

  async updateStepper(path: string) {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    let tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  setClassActive(value: boolean): string {
    return value ? 'active' : 'inactive';
  }

  async updateResumeStep() {
    const resumeStep = await lastValueFrom(
      this.store.select(fromInfo.selectCurrentResumeStep).pipe(take(1))
    );
    const tmpResumeStep = cloneResumeStep(resumeStep);

    const stepResumeStep = tmpResumeStep.steps?.find(
      x => x.id == this.resource.resumestep.houseapartment
    );

    if (stepResumeStep) {
      stepResumeStep.step = this.resource.header.subStepHouseApartment;
      stepResumeStep.isVisible = true;
    } else {
      tmpResumeStep.steps?.push({
        id: this.resource.resumestep.houseapartment,
        step: this.resource.header.subStepHouseApartment,
        url: this.resource.resumestep.houseapartment,
        isVisible: true
      });
    }
    this.store.dispatch(fromInfo.updateResumeStep({ payload: tmpResumeStep }));
  }

  async nextStep() {
    await this.updateResumeStep();

    if (this.noSelected) {
      this.store.dispatch(
        fromPath.updatePreviousType({
          previousPathType: this.path
        })
      );

      this.store.dispatch(
        fromPath.updateType({
          pathType: PathType.HOUSING
        })
      );
    } else {
      this.store.dispatch(
        fromPath.updateType({
          pathType: PathType.HOUSING_ETUDIANTE
        })
      );
    }

    await this.updateStepper(this.path);

    this.store.dispatch(fromAddress.patchIsEtudiant({ isEtudiant: this.yesSelected }));
    this.router.navigate([`${ROOT_PATH}${ADDRESS_PATH}`]);
  }
}
